import LabelValuePair from "./LabelValuePair";
import LastUpdatedOn from "./LastUpdatedOn";
import Unit from "./Unit";
import Text from "./Text";
import Date from "./Date";
import StartAndEndDate from "./StartAndEndDate";

export default {
  LabelValuePair,
  LastUpdatedOn,
  Unit,
  Text,
  Date,
  StartAndEndDate
};



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/index.js